var _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgKpmgWarning(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    viewBox: "0 0 165 140"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M57.723 122.563h84.554a7.94 7.94 0 006.817-3.891 8.04 8.04 0 00.172-7.883l-42.274-78.996c-3-5.598-10.984-5.598-13.984 0l-42.274 78.996a8.04 8.04 0 00.172 7.883 7.935 7.935 0 006.817 3.89zm0 0",
    fill: "#eaaa00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M98.574 59.95L100 90.401l1.422-30.437a1.447 1.447 0 00-.399-1.063 1.418 1.418 0 00-2.055.008 1.437 1.437 0 00-.394 1.04zm0 0",
    fill: "none",
    strokeWidth: 8,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M100 110.332c-2.742 0-4.96-2.234-4.96-4.992s2.218-4.992 4.96-4.992c2.738 0 4.96 2.234 4.96 4.992s-2.222 4.992-4.96 4.992zm0 0",
    fill: "#fff"
  })));
}

export default SvgKpmgWarning;